import { useEffect, useState } from 'react';
import styled from 'styled-components';
import AOS from 'aos';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import setAuthorizationToken from 'assets/js/Server';

const Login = () => {
  const [userInfo, setUserInfo] = useState({
    userId: '',
    userPassword: ''
  });

  // [수정] 기기 및 권한별 이동 로직 분리
  const checkDevice = () => {
    if (localStorage.getItem('userRank') === '2') {
      document.location.href = '/customer/status';
    } else if (localStorage.getItem('userRank') === '3') {
      document.location.href = '/customer/service';
    } else {
      if (Common.getDeviceType() === 1) {
        document.location.href = '/home';
      } else {
        document.location.href = '/client/state';
      }
    }
  };

  // [추가] 로그인 상태와 비밀번호 변경 여부를 종합적으로 체크하는 함수
  const checkAuthStatus = () => {
    const token = localStorage.getItem('accessToken');
    const pwdChangeYn = localStorage.getItem('userPasswordChangeYn');

    if (!Common.isEmpty(token)) {
      // 토큰이 있더라도 비밀번호 변경이 'N'이면 패스워드 변경 페이지가 우선
      if (pwdChangeYn === 'N') {
        if (window.location.pathname !== '/password') {
          document.location.href = '/password';
        }
      } else {
        checkDevice();
      }
    }
  };

  const onEnter = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      userLogin();
    }
  };

  const userLogin = () => {
    Server.sendPost('user/login', {
      userId: userInfo.userId,
      userPassword: userInfo.userPassword
    }, isLogin).then();
  };

  useEffect(() => {
    AOS?.init({ duration: 1000 });

    // [수정] 단순 checkDevice가 아닌 인증 상태 및 비번 변경 여부 통합 체크
    checkAuthStatus();
  }, []);

  const isLogin = res => {
    if (res['apiCode'] === 'S001') {
      const result = res['resultObject'];

      localStorage.setItem('accessToken', result['accessToken']);
      localStorage.setItem('refreshToken', result['refreshToken']);
      localStorage.setItem('userId', userInfo.userId);
      localStorage.setItem('userRank', result['userRank']);

      // [중요] 응답받은 비밀번호 변경 여부를 로컬스토리지에 저장하여 useEffect가 인식하게 함
      localStorage.setItem('userPasswordChangeYn', result['userPasswordChangeYn']);

      setAuthorizationToken(result['accessToken']);

      if (result?.['userPasswordChangeYn'] === 'N') {
        document.location.href = '/password';
      } else {
        checkDevice();
      }
    }
  };

  return (
    <>
      <VisualWrap>
        <Inner>
          <LoginBox>
            <LogoBox>
              <img src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/ust_logo.webp' alt='ust logo'/>
            </LogoBox>
            <LoginForm>
              <LoginInput
                type='text'
                id='id'
                name='id'
                placeholder='ID'
                onKeyDown={(event) => onEnter(event)}
                onChange={(e) => {
                  setUserInfo({
                    ...userInfo,
                    userId: e.target.value,
                  });
                }}
              />
              <LoginInput
                type='password'
                id='pw'
                name='pw'
                autoComplete='off'
                placeholder='Password'
                onKeyDown={(event) => onEnter(event)}
                onChange={(e) => {
                  setUserInfo({
                    ...userInfo,
                    userPassword: e.target.value,
                  });
                }}
              />
              <SignupWrapper>
                <SignupBtn onClick={() => { /* 회원가입 로직 */ }}>
                  Sign Up
                </SignupBtn>
              </SignupWrapper>
            </LoginForm>
            <LoginBtn onClick={userLogin}>Login</LoginBtn>
          </LoginBox>
        </Inner>
      </VisualWrap>
    </>
  );
}

/* 스타일 컴포넌트 생략 (기본과 동일) */
const VisualWrap = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/login_bg.webp') no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
  }
`;

const Inner = styled.div`
  z-index: 3;
  position: relative;
  max-width: 1200px;
`;

const LoginBox = styled.div`
  text-align: center;
`;

const LogoBox = styled.div`
  position: relative;
`;

const LoginForm = styled.div`
  margin: 55px 0 60px;
  display: flex;
  flex-direction: column;
  gap: 18px 0;
`;

const LoginInput = styled.input`
  width: 320px;
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  outline: none;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  &::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #777777;
  }
`;

const LoginBtn = styled.button`
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  background: #0072B9;
  border-radius: 100px;
  cursor: pointer;
`;

const SignupWrapper = styled.div`
  width: 320px;
  margin-top: -10px;
  text-align: right;
`;

const SignupBtn = styled.span`
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  text-decoration: underline;
  opacity: 0.8;
  &:hover {
    opacity: 1;
    color: #0072B9;
  }
`;

export default Login;
